import { PrivilegeEnum as t } from "@hprofits/shared/auth";
import { ocPrivate as r } from "../common/auth/procedure-builders.js";
import "../swagger/security.js";
import { SwaggerTags as i } from "../swagger/tags.js";
import { AdUnitsQuerySchema as o, AdUnitsResponseSchema as m } from "./schemas.js";
const p = {
  adUnit: {
    /**
     * List ad units, optionally filtered by free-text search (name or id), type, format, owner or
     * site.
     */
    findAll: r([t.ReadAdmin]).route({
      method: "GET",
      path: "/ad-units",
      summary: "List ad units",
      tags: [i.AD_UNITS.name]
    }).input(o).output(m).errors({})
  }
};
export {
  p as adUnitContract
};
//# sourceMappingURL=contract.js.map
